import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NgxWebstorageModule } from 'ngx-webstorage';

// import modules
import { FxServicesModule } from '../services/fx-services.module';
import { FxComponentsModule } from '../components/fx-components.module';
// import main
import { MainComponent } from './main/main.component';
import { MainFlexComponent } from './main/main-flex.component';
// import pages
import { AppEntryComponent } from './pages/app-entry.component';
import { ErrorComponent } from './pages/error.component';
import { BlankComponent } from './pages/blank.component';
import { LoginPageComponent } from './pages/login-page.component';
import { IFrameComponent } from './pages/iframe.component';
import { LoginComponent } from './pages/login.component';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        NgZorroAntdModule,
        NgxWebstorageModule,
        RouterModule,
        
        FxServicesModule,
        FxComponentsModule,
    ],
    declarations: [
        MainComponent, 
        MainFlexComponent,
        AppEntryComponent, 
        BlankComponent, 
        ErrorComponent,
        LoginPageComponent,
        IFrameComponent,
        LoginComponent
    ],
    exports: [
        MainComponent, 
        MainFlexComponent,
        AppEntryComponent, 
        BlankComponent, 
        ErrorComponent,
        LoginPageComponent,
        IFrameComponent,
    ]
})
export class FxLayoutsModule { }
